import moment from 'moment/moment';
import camelCase from 'lodash/camelCase';
import { formatByMask } from 'src/common/helpers/common.helpers';

import { FileDownloadLink } from 'src/components/employee/components/file-download-link';
import { BooleanSwitchInfo } from 'src/components/employee/components/boolean-switch-info';
import { IWorkingConditionContract } from './employee.interfaces';

export const getCorrectFormatEmployeeInfoField = ({
  value,
  key,
  t,
}: {
  value: any;
  key: string;
  t: Function;
}) => {
  switch (key) {
    case 'phoneNumber':
      return value ? formatByMask(value, '+## ### ### #######') : '-';
    case 'birthday':
      return value ? moment(value).format('DD.MM.YYYY') : '-';
    case 'gender':
      return value ? t(`employee:employeePersonalInfo.labels.${value?.toLowerCase()}`) : '-';
    case 'visaExpirationDate':
      return value ? moment(value).format('DD.MM.YYYY') : '-';
    case 'residencePermissionExpireDate':
      return value ? moment(value).format('DD.MM.YYYY') : '-';
    case 'workPermissionExpireDate':
      return value ? moment(value).format('DD.MM.YYYY') : '-';
    case 'certificateOfStudyExpireDate':
      return value ? moment(value).format('DD.MM.YYYY') : '-';
    case 'driversLicenses':
      return value ? t(`common:labels.${value ? 'yes' : 'no'}`) : '-';
    case 'maritalStatus':
      return value ? t(`employee:emergencyDetails.labels.${value.toLowerCase()}`) : '-';
    case 'schoolName':
      return value ? t(`employee:labels.schoolOptions.${camelCase(value.toLowerCase())}`) : '-';
    case 'country':
      return value ? t(`common:country.${value}`) : '-';
    case 'nationality':
      return value ? t(`common:country.${value}`) : '-';
    case 'companyPhoneNumber':
      return value ? formatByMask(value, '+## ### ### #######') : '-';
    case 'personalPhoneNumber':
      return value ? formatByMask(value, '+## ### ### #######') : '-';
    case 'emergencyPhoneNumber':
      return value ? formatByMask(value, '+## ### ### #######') : '-';
    case 'countryOfBirth':
      return value ? t(`common:country.${value}`) : '-';
    case 'healthInsuranceType':
      return value ? t(`employee:paymentAndInsurance.labels.healthInsuranceOptions.${value}`) : '-';
    case 'highestTrainingDegree':
      return value
        ? t(`employee:labels.highestTrainingOptions.${camelCase(value.toLowerCase())}`)
        : '-';
    case 'status':
      return value
        ? t(`employee:employeePersonalInfo.labels.statuses.${camelCase(value.toLowerCase())}`)
        : '-';
    case 'workPermissionNeeded':
      return <BooleanSwitchInfo t={t} defaultChecked={!!value} />;
    case 'hasCertificateOfStudy':
      return <BooleanSwitchInfo t={t} defaultChecked={!!value} />;
    case 'residencePermissionNeeded':
      return <BooleanSwitchInfo t={t} defaultChecked={!!value} />;
    case 'personalIdCardFront':
      return <FileDownloadLink file={value} />;
    case 'personalIdCardBack':
      return <FileDownloadLink file={value} />;
    default:
      return value || '-';
  }
};

export const getWorkingConditionActualContract = (contracts: IWorkingConditionContract[]) => {
  return contracts.reduce((a, b) => {
    return new Date(a.hireDate) > new Date(b.hireDate) ? a : b;
  });
};
